import { FunctionComponent, ReactNode } from "react";
import { Input } from "./ui/input";
import { cn } from "@/lib/utils/ui";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface InputFieldEditButtonProps {
  value: string;
  setValue: (newValue: string) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  trailingIcon?: ReactNode;
  trailingTooltip?: string;
}

const InputFieldEditButton: FunctionComponent<InputFieldEditButtonProps> = ({
  value,
  setValue,
  placeholder,
  className,
  disabled = false,
  trailingIcon,
  trailingTooltip,
}) => {
  const fieldClassName = cn(
    "border-none disabled:cursor-auto disabled:opacity-100",
    className,
  );
  const leadingIcon = trailingIcon ? (
    <span className="inline-flex shrink-0 items-center text-muted-foreground">
      {trailingTooltip ? (
        <Tooltip>
          <TooltipTrigger asChild>
            <span className="inline-flex items-center">{trailingIcon}</span>
          </TooltipTrigger>
          <TooltipContent>{trailingTooltip}</TooltipContent>
        </Tooltip>
      ) : (
        trailingIcon
      )}
    </span>
  ) : null;

  if (disabled) {
    return (
      <div className="inline-flex w-fit max-w-full shrink-0 items-center gap-1.5">
        {leadingIcon}
        <span
          className={cn(
            "truncate text-base md:text-sm",
            fieldClassName,
            "h-auto w-auto min-w-0 flex-none py-0 pr-0",
            trailingIcon ? "pl-0" : "pl-3",
          )}
        >
          {value || placeholder}
        </span>
      </div>
    );
  }

  return (
    <div className="relative flex w-full max-w-sm items-center gap-1.5">
      {leadingIcon}
      <Input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className={cn(fieldClassName, trailingIcon && "pl-0")}
        disabled={disabled}
      />
    </div>
  );
};

export default InputFieldEditButton;
